import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../utils/useFetch";
import { toast } from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";

const ForgetSubCode = () => {
  const [phone, setPhone] = useState<string>("");
  const isFormDataValidated = phone.length === 11;
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const signInFetch = async () => {
    const _formData = new FormData();
    _formData.append("phone", phone);
    const response = await fetch(API_BASE_URL + "forgot", {
      method: "POST",
      body: _formData,
    });
    setIsLoading(true);
    return response.json();
  };

  const handleForm = (e: any) => {
    console.log("HANDLE FORM");

    setIsLoading(true);
    e.preventDefault();
    signInFetch().then((response) => {
      setIsLoading(false);
      if (response) {
        toast.success("کد اشتراک شما از طریق پیامک ارسال شد");
        navigate("/signin");
      } else if (response === false) {
        toast.error("خطا! کد اشتراک یا شماره تلفن اشتباه است");
      }
    });
  };

  return (
    <>
      <div className=' w-full mx-auto p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] md:h-full'>
        <div className=' w-full h-full max-w-md md:h-auto mx-auto'>
          <div className=' bg-white rounded shadow'>
            <div className='px-6 py-6 lg:px-8'>
              <div className='mb-8 text-4xl font-bold text-center'>
                فراموشی کد اشتراک
              </div>
              <form
                className='space-y-6'
                action='#'
                onSubmit={(e) => handleForm(e)}
              >
                <div>
                  <label
                    htmlFor='phone'
                    className='block mb-2 text-sm font-medium  '
                  >
                    شماره تلفن
                  </label>
                  <input
                    type='number'
                    name='phone'
                    minLength={11}
                    maxLength={11}
                    onChange={(e) => setPhone(e.target.value)}
                    className='bg-gray-50 border border-gray-300  text-sm rounded outline-rose-700 block w-full p-2'
                    required
                  />
                </div>

                <div className='flex items-center'>
                  <button
                    type='submit'
                    disabled={!isFormDataValidated && !isLoading}
                    className='flex-1 w-full cursor-pointer text-white bg-rose-900 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'
                  >
                    {isLoading ? (
                      <FontAwesomeIcon
                        icon={faCircleNotch}
                        className='rotate-animation'
                      />
                    ) : (
                      "ارسال کد"
                    )}
                  </button>
                </div>

                <div className='text-sm font-medium text-gray-500 dark:text-gray-300'></div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetSubCode;
